// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saveBtns[data-v-b642c632]{width:200px;text-align:center;margin-top:50px}.bgcMainColor[data-v-b642c632]{width:100px}.formClass[data-v-b642c632]{display:flex;flex-wrap:wrap;width:700px}.formClass .items[data-v-b642c632]{width:50%}.formClass[data-v-b642c632] .el-form-item__label{font-size:16px;font-weight:700;padding:0}", ""]);
// Exports
module.exports = exports;
